import {
  Companion_getInstance3dtgneissrfcv as Companion_getInstance,
  Creditv1m3yq08fl3i as Credit,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_incident(_this__u8e3s4) {
  return _this__u8e3s4.prop(Credit_incident_getInstance());
}
function get_projectCreditGroup(_this__u8e3s4) {
  return _this__u8e3s4.prop(Credit_projectCreditGroup_getInstance());
}
function get_timestamp(_this__u8e3s4) {
  return _this__u8e3s4.prop(Credit_timestamp_getInstance());
}
function prepareCreditFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Credit_amount_getInstance(), Credit_timestamp_getInstance(), Credit_lineItem_getInstance(), Credit_incident_getInstance(), Credit_projectCreditGroup_getInstance(), Credit_reason_getInstance(), Credit_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Credit_incident$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Credit_incident$_get_name_$ref_jx7sor() {
  return (p0) => p0.k20();
}
function Credit_incident$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_incident$_get_serializer_$ref_bnd1n8() {
  return (p0) => p0.j2j();
}
function Credit_incident$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Credit_incident$_get_annotations_$ref_a50xe8() {
  return (p0) => p0.bz();
}
var Credit_incidentClass;
function Credit_incident() {
  if (Credit_incidentClass === VOID) {
    class $ {
      constructor() {
        Credit_incident_instance = this;
        var tmp = this;
        tmp.u5q_1 = lazy(Credit_incident$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v5q_1 = lazy(Credit_incident$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w5q_1 = lazy(Credit_incident$annotations$delegate$lambda);
        this.x5q_1 = null;
        this.y5q_1 = 'null';
      }
      k20() {
        var tmp0 = this.u5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_incident$_get_name_$ref_jx7sor(), null);
        return tmp0.f2();
      }
      z5q(receiver) {
        return receiver.d5r_1;
      }
      m2j(receiver) {
        return this.z5q(receiver instanceof Credit() ? receiver : THROW_CCE());
      }
      h5r(receiver, value) {
        return receiver.i5r(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.h5r(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_incident$_get_serializer_$ref_bnd1n8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w5q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_incident$_get_annotations_$ref_a50xe8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_incident', VOID, VOID, [SerializableProperty()]);
    Credit_incidentClass = $;
  }
  return Credit_incidentClass;
}
var Credit_incident_instance;
function Credit_incident_getInstance() {
  if (Credit_incident_instance === VOID)
    new (Credit_incident())();
  return Credit_incident_instance;
}
function Credit_projectCreditGroup$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Credit_projectCreditGroup$_get_name_$ref_ls4hq8() {
  return (p0) => p0.k20();
}
function Credit_projectCreditGroup$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_projectCreditGroup$_get_serializer_$ref_wx2pax() {
  return (p0) => p0.j2j();
}
function Credit_projectCreditGroup$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Credit_projectCreditGroup$_get_annotations_$ref_9y1y8b() {
  return (p0) => p0.bz();
}
var Credit_projectCreditGroupClass;
function Credit_projectCreditGroup() {
  if (Credit_projectCreditGroupClass === VOID) {
    class $ {
      constructor() {
        Credit_projectCreditGroup_instance = this;
        var tmp = this;
        tmp.j5r_1 = lazy(Credit_projectCreditGroup$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k5r_1 = lazy(Credit_projectCreditGroup$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l5r_1 = lazy(Credit_projectCreditGroup$annotations$delegate$lambda);
        this.m5r_1 = null;
        this.n5r_1 = 'null';
      }
      k20() {
        var tmp0 = this.j5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_projectCreditGroup$_get_name_$ref_ls4hq8(), null);
        return tmp0.f2();
      }
      z5q(receiver) {
        return receiver.e5r_1;
      }
      m2j(receiver) {
        return this.z5q(receiver instanceof Credit() ? receiver : THROW_CCE());
      }
      o5r(receiver, value) {
        return receiver.i5r(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.o5r(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_projectCreditGroup$_get_serializer_$ref_wx2pax(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_projectCreditGroup$_get_annotations_$ref_9y1y8b(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_projectCreditGroup', VOID, VOID, [SerializableProperty()]);
    Credit_projectCreditGroupClass = $;
  }
  return Credit_projectCreditGroupClass;
}
var Credit_projectCreditGroup_instance;
function Credit_projectCreditGroup_getInstance() {
  if (Credit_projectCreditGroup_instance === VOID)
    new (Credit_projectCreditGroup())();
  return Credit_projectCreditGroup_instance;
}
function Credit_timestamp$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Credit_timestamp$_get_name_$ref_ujdmmb() {
  return (p0) => p0.k20();
}
function Credit_timestamp$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_timestamp$_get_serializer_$ref_owjn18() {
  return (p0) => p0.j2j();
}
function Credit_timestamp$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Credit_timestamp$_get_annotations_$ref_pf0u6w() {
  return (p0) => p0.bz();
}
var Credit_timestampClass;
function Credit_timestamp() {
  if (Credit_timestampClass === VOID) {
    class $ {
      constructor() {
        Credit_timestamp_instance = this;
        var tmp = this;
        tmp.p5r_1 = lazy(Credit_timestamp$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q5r_1 = lazy(Credit_timestamp$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r5r_1 = lazy(Credit_timestamp$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.s5r_1 = get_default(Companion_instance).d1m();
        this.t5r_1 = 'now()';
      }
      k20() {
        var tmp0 = this.p5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_timestamp$_get_name_$ref_ujdmmb(), null);
        return tmp0.f2();
      }
      z5q(receiver) {
        return receiver.b5r_1;
      }
      m2j(receiver) {
        return this.z5q(receiver instanceof Credit() ? receiver : THROW_CCE());
      }
      u5r(receiver, value) {
        return receiver.i5r(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.u5r(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_timestamp$_get_serializer_$ref_owjn18(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_timestamp$_get_annotations_$ref_pf0u6w(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_timestamp', VOID, VOID, [SerializableProperty()]);
    Credit_timestampClass = $;
  }
  return Credit_timestampClass;
}
var Credit_timestamp_instance;
function Credit_timestamp_getInstance() {
  if (Credit_timestamp_instance === VOID)
    new (Credit_timestamp())();
  return Credit_timestamp_instance;
}
function Credit_amount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Credit_amount$_get_name_$ref_pn5tmd() {
  return (p0) => p0.k20();
}
function Credit_amount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_amount$_get_serializer_$ref_1xc9ma() {
  return (p0) => p0.j2j();
}
function Credit_amount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Credit_amount$_get_annotations_$ref_4s5aq2() {
  return (p0) => p0.bz();
}
var Credit_amountClass;
function Credit_amount() {
  if (Credit_amountClass === VOID) {
    class $ {
      constructor() {
        Credit_amount_instance = this;
        var tmp = this;
        tmp.v5r_1 = lazy(Credit_amount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w5r_1 = lazy(Credit_amount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x5r_1 = lazy(Credit_amount$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.v5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_amount$_get_name_$ref_pn5tmd(), null);
        return tmp0.f2();
      }
      y5r(receiver) {
        return receiver.a5r_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.y5r(receiver instanceof Credit() ? receiver : THROW_CCE()));
      }
      z5r(receiver, value) {
        return receiver.i5r(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.z5r(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_amount$_get_serializer_$ref_1xc9ma(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x5r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_amount$_get_annotations_$ref_4s5aq2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_amount', VOID, VOID, [SerializableProperty()]);
    Credit_amountClass = $;
  }
  return Credit_amountClass;
}
var Credit_amount_instance;
function Credit_amount_getInstance() {
  if (Credit_amount_instance === VOID)
    new (Credit_amount())();
  return Credit_amount_instance;
}
function Credit_lineItem$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Credit_lineItem$_get_name_$ref_izk5qe() {
  return (p0) => p0.k20();
}
function Credit_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_lineItem$_get_serializer_$ref_5yjixt() {
  return (p0) => p0.j2j();
}
function Credit_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Credit_lineItem$_get_annotations_$ref_c8tsat() {
  return (p0) => p0.bz();
}
var Credit_lineItemClass;
function Credit_lineItem() {
  if (Credit_lineItemClass === VOID) {
    class $ {
      constructor() {
        Credit_lineItem_instance = this;
        var tmp = this;
        tmp.b5s_1 = lazy(Credit_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5s_1 = lazy(Credit_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5s_1 = lazy(Credit_lineItem$annotations$delegate$lambda);
        this.e5s_1 = null;
        this.f5s_1 = 'null';
      }
      k20() {
        var tmp0 = this.b5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_lineItem$_get_name_$ref_izk5qe(), null);
        return tmp0.f2();
      }
      z5q(receiver) {
        return receiver.c5r_1;
      }
      m2j(receiver) {
        return this.z5q(receiver instanceof Credit() ? receiver : THROW_CCE());
      }
      h5r(receiver, value) {
        return receiver.i5r(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.h5r(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_lineItem$_get_serializer_$ref_5yjixt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_lineItem$_get_annotations_$ref_c8tsat(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_lineItem', VOID, VOID, [SerializableProperty()]);
    Credit_lineItemClass = $;
  }
  return Credit_lineItemClass;
}
var Credit_lineItem_instance;
function Credit_lineItem_getInstance() {
  if (Credit_lineItem_instance === VOID)
    new (Credit_lineItem())();
  return Credit_lineItem_instance;
}
function Credit_reason$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function Credit_reason$_get_name_$ref_eihjux() {
  return (p0) => p0.k20();
}
function Credit_reason$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_reason$_get_serializer_$ref_o4gly6() {
  return (p0) => p0.j2j();
}
function Credit_reason$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function Credit_reason$_get_annotations_$ref_he8msi() {
  return (p0) => p0.bz();
}
var Credit_reasonClass;
function Credit_reason() {
  if (Credit_reasonClass === VOID) {
    class $ {
      constructor() {
        Credit_reason_instance = this;
        var tmp = this;
        tmp.g5s_1 = lazy(Credit_reason$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h5s_1 = lazy(Credit_reason$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i5s_1 = lazy(Credit_reason$annotations$delegate$lambda);
        this.j5s_1 = '';
        this.k5s_1 = '""';
      }
      k20() {
        var tmp0 = this.g5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_reason$_get_name_$ref_eihjux(), null);
        return tmp0.f2();
      }
      z5q(receiver) {
        return receiver.f5r_1;
      }
      m2j(receiver) {
        return this.z5q(receiver instanceof Credit() ? receiver : THROW_CCE());
      }
      l5s(receiver, value) {
        return receiver.i5r(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.l5s(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_reason$_get_serializer_$ref_o4gly6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_reason$_get_annotations_$ref_he8msi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_reason', VOID, VOID, [SerializableProperty()]);
    Credit_reasonClass = $;
  }
  return Credit_reasonClass;
}
var Credit_reason_instance;
function Credit_reason_getInstance() {
  if (Credit_reason_instance === VOID)
    new (Credit_reason())();
  return Credit_reason_instance;
}
function Credit_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function Credit_readBy$_get_name_$ref_e73r6o() {
  return (p0) => p0.k20();
}
function Credit_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Credit_readBy$_get_serializer_$ref_q30ngn() {
  return (p0) => p0.j2j();
}
function Credit_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function Credit_readBy$_get_annotations_$ref_ro3duz() {
  return (p0) => p0.bz();
}
var Credit_readByClass;
function Credit_readBy() {
  if (Credit_readByClass === VOID) {
    class $ {
      constructor() {
        Credit_readBy_instance = this;
        var tmp = this;
        tmp.m5s_1 = lazy(Credit_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5s_1 = lazy(Credit_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5s_1 = lazy(Credit_readBy$annotations$delegate$lambda);
        this.p5s_1 = emptySet();
        this.q5s_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.m5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Credit_readBy$_get_name_$ref_e73r6o(), null);
        return tmp0.f2();
      }
      z5q(receiver) {
        return receiver.g5r_1;
      }
      m2j(receiver) {
        return this.z5q(receiver instanceof Credit() ? receiver : THROW_CCE());
      }
      r5s(receiver, value) {
        return receiver.i5r(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Credit() ? receiver : THROW_CCE();
        return this.r5s(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Credit_readBy$_get_serializer_$ref_q30ngn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Credit_readBy$_get_annotations_$ref_ro3duz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Credit_readBy', VOID, VOID, [SerializableProperty()]);
    Credit_readByClass = $;
  }
  return Credit_readByClass;
}
var Credit_readBy_instance;
function Credit_readBy_getInstance() {
  if (Credit_readBy_instance === VOID)
    new (Credit_readBy())();
  return Credit_readBy_instance;
}
//region block: exports
export {
  get_incident as get_incidentys14r5mjqskx,
  prepareCreditFields as prepareCreditFields263pps5obgt9k,
  get_projectCreditGroup as get_projectCreditGroupjukbcz0r5fa1,
  get_timestamp as get_timestampsmki8tl7yqiq,
};
//endregion

//# sourceMappingURL=CreditFields.mjs.map
